import { QueryClient } from '@tanstack/react-query'

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: true,
      // refetchOnMount: false removed - we need initial fetch!
      refetchOnReconnect: false, // Don't refetch on reconnect
    },
    mutations: {
      retry: 1,
    },
  },
})
